import { render, staticRenderFns } from "./MyRegister.vue?vue&type=template&id=0b3e6738&"
import script from "./MyRegister.vue?vue&type=script&lang=js&"
export * from "./MyRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports